export const HTTP_STATUS_UNAUTHORIZED = 401;
export const HTTP_STATUS_GONE = 410;

export const HTTP_STATUS_PRECONDITION_FAILED = 412;

export const GLOBAL_ERROR_STATUS_CODES = [
	400, //Bad request
	403, //Forbidden
	404, //Not-Found
	409, //Conflict
	500, //Internal Server Error
	502, //Bad gateway
	504, //Gateway timeout
];

export const SESSION_ERROR_STATUS_CODES = [
	HTTP_STATUS_UNAUTHORIZED, //expired token
	HTTP_STATUS_GONE, //expired token
];

export const AUTHORIZATION_HEADER = 'Authorization';
export const BEARER_PREFIX = 'Bearer';
export const GRANT_TYPE_REFRESH_TOKEN = 'refresh_token';
export const DEFAULT_SCOPE = 'myabb openid profile';
export const ERROR_MISSING_RESPONSE = 'Missing response object!';
export const CONTENT_TYPE_FORM_URLENCODED = 'application/x-www-form-urlencoded';
export const TOKEN_ENDPOINT = 'token';
